module.exports = __webpack_public_path__ + "static/14-92e739ccf5520f1bbedc1a3a079bc84b.jpg";